import { Body, Controller, Post } from '@nestjs/common';
import { DlModuleService } from './dl-module.service';
import { CommonResponseModel, CreateDlMasterReqDto, CreatePaRequestListDto, PaginationDto, ProductionPlanModel } from '@project-management-system/shared-models';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';

@Controller('dl-automation')
export class DlModuleController {
  constructor(private readonly dlModuleService: DlModuleService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

  @Post('/getDlMastersData')
  async getDlMastersData(): Promise<CommonResponseModel> {
    try {
      return await this.dlModuleService.getDlMastersData()
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
    }
  }

  @Post('saveDlMasterData')
  async saveDlMasterData(@Body() req: CreateDlMasterReqDto[]): Promise<CommonResponseModel> {
    try {
      return await this.dlModuleService.saveDlMasterData(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
    }
  }

  @Post('saveDlProductionPlan')
  async saveDlProductionPlan(@Body() req: ProductionPlanModel[]): Promise<CommonResponseModel> {
    try {
      return await this.dlModuleService.saveDlProductionPlan(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
    }
  }


  @Post('savPaRequestList')
  async savPaRequestList(@Body() req: CreatePaRequestListDto[]): Promise<CommonResponseModel> {
    try {
      return await this.dlModuleService.savPaRequestList(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
    }
  }


  @Post('getProductionPlan')
  async getProductionPlan(): Promise<CommonResponseModel> {
    try {
      return await this.dlModuleService.getProductionPlan()
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
    }
  }



  @Post('getPARequestList')
  async getPARequestList(@Body() req: PaginationDto): Promise<CommonResponseModel> {
    try {
      return await this.dlModuleService.getPARequestList(req)
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
    }
  }

}
